import type {
	NotificationServiceContract,
	PushMessage,
	PushMessageHandler,
	PushUnsubscribe,
} from 'src/data/services/types/NotificationServiceTypes';

/**
 * Browsers have no Firebase Cloud Messaging in this app: web push needs a service worker,
 * its own VAPID key pair and a second registration path on the backend, all of which is
 * out of scope. So every method is a no-op that answers "nothing here" rather than
 * throwing — the callers already treat a missing token as "this install has no push".
 *
 * A sibling, not a Platform.OS branch, because the whole implementation differs and this
 * also keeps @react-native-firebase/messaging out of the web bundle entirely. That import
 * throws in a browser, and PermissionsAndroid does not exist in react-native-web.
 */
const noopUnsubscribe: PushUnsubscribe = () => undefined;

class NotificationServiceWeb implements NotificationServiceContract {
	init(): Promise<void> {
		// Nothing to initialise.
		return Promise.resolve();
	}

	requestUserPermission(): Promise<void> {
		// No permission to ask for without push support.
		return Promise.resolve();
	}

	getToken(): Promise<string | undefined> {
		return Promise.resolve(undefined);
	}

	onForegroundMessage(_handler: PushMessageHandler): PushUnsubscribe {
		return noopUnsubscribe;
	}

	onNotificationOpened(_handler: PushMessageHandler): PushUnsubscribe {
		return noopUnsubscribe;
	}

	getInitialNotification(): Promise<PushMessage | null> {
		return Promise.resolve(null);
	}
}

export default new NotificationServiceWeb();
